import React from "react";
import { GROUP, PRIMARY, DIVISIONS } from "../../CompanyInfo";

const namesObject = {
    companyName: GROUP.name,
    email: GROUP.email,
    website: GROUP.website,
    GSTIN: PRIMARY.gst,
    lastUpdated: "09/09/2026",
};

const PrivacyPolicy = () => {
    return (
        <div className="p-6 max-w-4xl mx-auto container ">
            <div className="bg-white p-4 m-5">
                <h1 className="text-3xl font-bold mb-4 text-center">Privacy Policy</h1>

                <p className="mb-4">
                    <span style={{ fontWeight: 500 }}>{namesObject.companyName}</span>&nbsp;Pharmaceutical Distributor
                    recognizes the importance of maintaining your
                    privacy. We value your privacy and appreciate your trust in us. This Policy
                    describes how we treat user information we collect on <a target="_blank" rel="noreferrer" href="/">{namesObject.website}</a> and other offline sources. This Privacy Policy
                    applies to current and former visitors to our website and to our online
                    customers. By visiting and/or using our website, you agree to this Privacy
                    Policy.
                </p>

                <p className="mb-4">
                    <a target="_blank" rel="noreferrer" href="/">{namesObject.website}</a> is a property of {namesObject.companyName},
                    having its registered office at
                </p>
                <p className="pt-2 mb-4">
                    {PRIMARY.addressLines.map((line, i) => (
                        <React.Fragment key={i}>{line}<br /></React.Fragment>
                    ))}
                    Karnataka, India<br />
                    <span style={{ fontWeight: 500 }}>GSTIN:</span> {namesObject.GSTIN}<br />
                    <span style={{ fontWeight: 500 }}>Drug Licence No:</span> {PRIMARY.drugLicences.join(", ")}
                </p>

                <h4 className="text-2xl font-semibold mt-6 mb-2">GROUP ENTITIES COVERED BY THIS POLICY</h4>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                    {DIVISIONS.map((d) => (
                        <li key={d.key}>
                            <span style={{ fontWeight: 500 }}>{d.name} ({d.label})</span> &mdash; {d.city}, {d.state}. GST {d.gst}.
                        </li>
                    ))}
                </ul>

                <h4 className="text-2xl font-semibold mt-6 mb-2">INFORMATION WE COLLECT</h4>
                <p className="mb-4">Contact information. We collect your Email, Mobile Number/Phone Number.</p>

                <h4 className="text-2xl font-semibold mt-6 mb-2">USE OF PERSONAL INFORMATION</h4>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                    <li>We use information to contact you: We might use the information you provide to contact you for confirmation of a purchase on our website or for other promotional purposes.</li>
                    <li>We use information to respond to your requests or questions. We might use your information to confirm your registration for any particular service requested on our website.</li>
                    <li>We use information to improve our products and services. We might use your information to customize your experience with us. This could include displaying content based upon your preferences.</li>
                    <li>We use information to look at site trends and customer interests. We may use your information to make our website and products better. We may combine information we get from you with information about you we get from third parties.</li>
                    <li>We use information for security purposes. We may use information to protect our company, our customers, or our websites.</li>
                    <li>We use information for marketing purposes. We might send you information about special promotions or offers. We might also tell you about new features or products. These might be our own offers or products, or third-party offers or products we think you might find interesting.</li>
                    <li>We use information to send you transactional communications. We might send you emails or SMS about your account or an order.</li>
                    <li>We use information as otherwise permitted by law.</li>
                </ul>

                <h4 className="text-2xl font-semibold mt-6 mb-2">Email Opt-Out</h4>
                <p className="mb-4">
                    You can opt out of receiving our marketing emails. To stop receiving our promotional
                    emails, please email <a href={"mailto:" + namesObject.email} className="text-blue-600 underline">{namesObject.email}</a>.
                </p>

                <h4 className="text-2xl font-semibold mt-6 mb-2">Updates to this policy</h4>
                <p className="mb-4">
                    This Privacy Policy was last updated on {namesObject.lastUpdated}. From time to time we may change
                    our privacy practices. Please check our site periodically for updates.
                </p>

                <h4 className="text-2xl font-semibold mt-6 mb-2">Jurisdiction</h4>
                <p className="mb-4">
                    If you choose to visit the website, your visit and any dispute over privacy is subject
                    to this Policy and the website's terms of use. In addition to the foregoing, any disputes
                    arising under this Policy shall be governed by the laws of India.
                </p>

                <p className="mt-8 text-sm text-gray-700" style={{ fontWeight: 500 }}>
                    Copyright &copy; {new Date().getFullYear()} {namesObject.companyName}
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
